import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var CURRENCIES_FOR_WHICH_WE_SHOW_NO_DECIMALS = ['HUF', 'CLP', 'ARS', 'IDR', 'SEK', 'NOK'];
var CURRENCIES_FOR_WHICH_WE_SHOW_THE_3_LETTERS_CODE = ['ARS', 'AUD', 'CAD', 'DKK', 'ISK', 'NOK', 'SEK'];
var CUSTOM_SYMBOL = {
  CLP: 'CLP $',
  COP: 'COP $',
  MXN: 'MXN $',
  RON: 'Lei'
};
var CURRENCIES_FOR_CUSTOM_SYMBOL_TO_FORCE_3_LETTERS_CODE_FIRST = Object.keys(CUSTOM_SYMBOL);
var ALL_3_LETTERS_CODE_CURRENCIES = CURRENCIES_FOR_WHICH_WE_SHOW_THE_3_LETTERS_CODE.concat(CURRENCIES_FOR_CUSTOM_SYMBOL_TO_FORCE_3_LETTERS_CODE_FIRST);
var selectCurrencyDisplay = function selectCurrencyDisplay(formattingCurrency) {
  return ALL_3_LETTERS_CODE_CURRENCIES.includes(formattingCurrency) ? 'code' : 'symbol';
};
var applyCustomSymbol = function applyCustomSymbol(formattedNumber, formattingCurrency) {
  return formattedNumber.replace(formattingCurrency, CUSTOM_SYMBOL[formattingCurrency] || formattingCurrency);
};
var isString = function isString(number) {
  return typeof number === 'string';
};
var createIntlFormatter = function createIntlFormatter(locale, currency, minimumFractionDigits, maximumFractionDigits) {
  return new Intl.NumberFormat(locale, {
    currency: currency,
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
    style: 'currency',
    useGrouping: true,
    currencyDisplay: selectCurrencyDisplay(currency)
  });
};
var parse = function parse(number) {
  return isString(number) ? parseFloat(number) : number;
};
var CurrencyFormatter = /*#__PURE__*/function () {
  function CurrencyFormatter(locale, currency, options) {
    _classCallCheck(this, CurrencyFormatter);
    this.locale = locale.replace('_', '-');
    this.currency = currency;
    this.minimumFractionDigits = options && options.minimumFractionDigits;
  }

  /**
   * This method formats a number according to the locale and formatting options of this NumberFormat object.
   *
   * @param {(string|number)} number - A `Number` or `BigInt` or number representation in `String` to format.
   * @return {string} A formatted string with currency and amount.
   *
   * @example
   *
   *     const instance = new CurrencyFormatter('en-GB', 'EUR');
   *     instance.formatNumber(1000);
   */
  return _createClass(CurrencyFormatter, [{
    key: "formatNumber",
    value: function formatNumber(number) {
      var currenciesToBeRounded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CURRENCIES_FOR_WHICH_WE_SHOW_NO_DECIMALS;
      var value = parse(number);
      var minDigits;
      var maxDigits;
      if (currenciesToBeRounded.includes(this.currency)) {
        minDigits = 0;
        maxDigits = 0;
      } else {
        minDigits = this.minimumFractionDigits;
      }
      return applyCustomSymbol(createIntlFormatter(this.locale, this.currency, minDigits, maxDigits).format(value), this.currency);
    }

    /**
     * This method formats a number according to the locale and formatting options of this NumberFormat object
     * and returns the largest integer less than or equal to a given number.
     *
     * @param {(string|number)} number - A `Number` or `BigInt` or number representation in `String` to format.
     * @return {string} A formatted string with currency and amount.
     *
     * @example
     *
     *     const instance = new CurrencyFormatter('en-GB', 'EUR');
     *     instance.formatNumberToFloor(1000);
     */
  }, {
    key: "formatNumberToFloor",
    value: function formatNumberToFloor(number) {
      var value = Math.floor(parse(number));
      var formattedValue = createIntlFormatter(this.locale, this.currency, 0).format(value);
      return applyCustomSymbol(formattedValue, this.currency);
    }

    /**
     * This method allows locale-aware formatting of strings produced by CurrencyFormatter.
     *
     * Please note, that it is not implemented on IE11,
     * where we added a polyfill that returns an array with just a literal object.
     *
     * @param {(string|number)} number - A `Number` or `BigInt` or number representation in `String` to format.
     * @return {object[]} An `Array` of objects containing the formatted number in parts.
     *
     * @example
     *
     *     const instance = new CurrencyFormatter('en-GB', 'EUR');
     *     instance.formatNumberToParts(1000);
     */
  }, {
    key: "formatNumberToParts",
    value: function formatNumberToParts(number) {
      var _this = this;
      var instance = createIntlFormatter(this.locale, this.currency, this.minimumFractionDigits);
      if (!instance.formatToParts) {
        return [{
          type: 'literal',
          value: this.formatNumber(number)
        }];
      }
      var value = parse(number);
      var parts = instance.formatToParts(value);
      return parts.map(function (part) {
        var numberFormatPart = {
          type: part.type,
          value: part.value
        };
        return part.type === 'currency' ? Object.assign(numberFormatPart, {
          value: applyCustomSymbol(part.value, _this.currency)
        }) : numberFormatPart;
      });
    }
  }]);
}();
export { CurrencyFormatter as default };